import React from 'react';
import T from 'prop-types';

import Modal from '../../../../../components/Modal';
import HubspotEmbeddedForm from '../../../../../components/Forms/HubspotEmbeddedForm';

const FormModal = ({
  open,
  formId,
  portalId,
  onModalClose,
}) => (
  <Modal
    modalClassName="hubspot-modal"
    open={open}
    closeButtonIconClass="hicon-close-2"
    onClose={onModalClose}
  >
    <div className="form-modal__container react-form">
      <div className="form react-form-box">
        <div className="text-part">
          <h3 className="title">Take our data for <br /> a test drive.</h3>
          <p className="subtitle">Request data on tickers you cover and receive a CSV <br className="hidden-lg-up" /> and analyst support for your own analysis.</p>
        </div>
        <div className="form-row react-form-container form-part">
          <HubspotEmbeddedForm
            portalId={portalId}
            formId={formId}
          />
        </div>
        <p className="form-modal__bottom-text">By submitting this form, you agree to Apptopia’s <br />
          <a href="/privacy">Privacy Policy</a> and <a href="/terms">Terms</a> of Service.
        </p>
      </div>
    </div>
  </Modal>
);

FormModal.propTypes = {
  open: T.bool.isRequired,
  formId: T.oneOfType([T.string, T.number]).isRequired,
  portalId: T.oneOfType([T.string, T.number]).isRequired,
  onModalClose: T.func.isRequired,
};

export default FormModal;
